import { render, staticRenderFns } from "./StudyProgramsModal.vue?vue&type=template&id=49683718&scoped=true&"
import script from "./StudyProgramsModal.vue?vue&type=script&lang=ts&"
export * from "./StudyProgramsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49683718",
  null
  
)

export default component.exports